module.exports = __webpack_public_path__ + "img/defend.c008aeb8.png";